(() => {
	'use strict';

const variantSelector = document.querySelector('variant-selects');
const dialog = document.querySelector('dialog#productGalleryModal');

	// Slider
	window.addEventListener('DOMContentLoaded', () => {
		const sliderElt = document.getElementById('productGallery');
		
		if (!sliderElt) return;

		const text = {
			prev: sliderElt.getAttribute('data-text-previous'),
			next: sliderElt.getAttribute('data-text-next'),
			slideX: sliderElt.getAttribute('data-text-slide'),
			select: sliderElt.getAttribute('data-text-select')
		};

		sliderElt.removeAttribute('data-text-previous');
		sliderElt.removeAttribute('data-text-next');
		sliderElt.removeAttribute('data-text-slide');
		sliderElt.removeAttribute('data-text-select');

		const slider = new Splide('#productGallery', {
			type: 'fade',
			rewind: true,
			easing: "ease",
			speed: 500,
			perPage: 1,
			perMove: 1,
			pagination: true,
			arrows: true,
			i18n: {
				prev: text.prev,
				next: text.next,
				slideX: text.slideX,
				select: text.select
			},
			gap: `12px`,
			breakpoints: {
				750: {
					arrows: false
				}
			}
		});

		slider.on('pagination:mounted', () => {
			createThumbnails(slider);
		});

		slider.on('mounted', () => {
			if (variantSelector) {
				syncVariants(slider);
			}

			if (dialog) {
				setLightbox(slider);
			}
		});

		slider.mount();
	});

	// THUMBNAILS
	const createThumbnails = (slider) => {
		const pagination = slider.Components.Pagination;
		const slides = slider.Components.Slides.get(true);

		slides.forEach((item) => {
			const button = pagination.items[item.index].button;
			const image = item.slide.querySelector('[data-thumbnail]');
			const imageUrl = image ? image.getAttribute('data-thumbnail') : null;
			if (!imageUrl) return;

			const thumbnail = document.createElement('img');
			thumbnail.src = imageUrl;
			thumbnail.width = '90';
			thumbnail.height = '90';
			thumbnail.alt = '';
			button.appendChild(thumbnail);
		});
	};

	// VARIANTS
	const syncVariants = (slider) => {
		const slides = slider.Components.Slides.get(true);
		const variantSlides = [];

		const displayCurrent = (variant) => {
			const next = variantSlides.find((slide) => {
				if (slide.variants.includes(variant)) {
					return true;
				}
			});		

			if (!next || slider.index === next.slide.index) return;

			slider.go(next.slide.index);
		}

		slides.forEach((item) => {
			const variantData = item.slide.getAttribute('data-variants')
			const variants = variantData ? variantData.split(',') : null;
			if (!(variants && variants.length)) return;

			variantSlides.push({
				slide: item,
				variants
			});
		});

		const startVariant = new URLSearchParams(window.location.search).get('variant');
		if (startVariant) {
			displayCurrent(startVariant);
		}
		
		subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
			displayCurrent(event.data.variant.id.toString());
		});

		// variantChangeがなく、1番目ヴァリエーションを表示
		subscribe(PUB_SUB_EVENTS.firstVariantSelect, () => {
			window.setTimeout(() => {
				slider.go(variantSlides[0].slide.index);
			}, 150); // 他のヴァリエーションと統一
		});
	};

	// MODAL
	const setLightbox = (slider) => {
		const createImg = () =>  {
			const img = document.createElement('img');
			img.width = '800';
			img.height = '800';
			img.alt = '';

			imgWrapper.appendChild(img);

			return img;			
		}

		const updateImg = (slide) =>  {
			const currentSlide = slider.Components.Slides.getAt(slider.index);
			const currentImg = currentSlide.slide.querySelector('[data-lightbox]');
			modalImg.src = currentImg.src;
		}

		const openModal = (e) => {
			e.preventDefault();
			document.body.classList.add('is-lightbox-open');
			updateImg();
			dialog.showModal();
		}

		const openBtn = document.getElementById('productGalleryModalBtn');
		const imgList = document.getElementById('productGallery-list');
		const imgWrapper = dialog.querySelector('.cm-modal__inner');
		const modalImg = imgWrapper ? createImg() : null;

		if (!(dialog && openBtn)) return;

		const closeBtn = dialog.querySelector('.cm-modal__close-btn');
		const prevBtn = dialog.querySelector('.cm-modal__arrow--prev');
		const nextBtn = dialog.querySelector('.cm-modal__arrow--next');
			
		openBtn.addEventListener('click', openModal);

		imgList.addEventListener('click', (e) => {
			if (e.target.hasAttribute(['data-lightbox'])) {
				openModal(e);
			}
		});
	
		if (closeBtn) {
			closeBtn.addEventListener('click', (e) => {
				e.preventDefault();
				dialog.close();
			});
		}

		dialog.addEventListener('click', (e) => {
			if (e.target.nodeName !== 'BUTTON' && e.target.nodeName !== 'IMG') {
				dialog.close();
			}
		});

		dialog.addEventListener('close', (e) => {
			document.body.classList.remove('is-lightbox-open');
		});
		

		if (prevBtn) {
			prevBtn.addEventListener('click', (e) => {
				slider.go('<');
				updateImg();
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', (e) => {
				slider.go('>');
				updateImg();
			});
		}
	}
})();